import rangeBucket from "@/util/range-bucket.mjs";

const winrateColorRange = rangeBucket([
  [0, "var(--perf-neg3)"],
  [47, "var(--perf-neg2)"],
  [48, "var(--perf-neg1)"],
  [50, "var(--perf-neutral)"],
  [52, "var(--perf-pos1)"],
  [53, "var(--perf-pos2)"],
  [54, "var(--perf-pos3)"],
]);
export const getWinRateColor = (percent) => winrateColorRange[percent];

const laneWinrateColorRange = rangeBucket([
  [0, "var(--perf-neg3)"],
  [35, "var(--perf-neg1)"],
  [50, "var(--perf-neutral)"],
  [65, "var(--perf-pos1)"],
  [80, "var(--perf-pos3)"],
]);
export const getLaneWinRateColor = (percent) => laneWinrateColorRange[percent];

const doombotsRange = rangeBucket([
  [0, "var(--perf-neg3)"],
  [3, "var(--perf-neg2)"],
  [5, "var(--perf-neg1)"],
  [8, "var(--perf-neutral)"],
  [12, "var(--perf-pos1)"],
  [15, "var(--perf-pos2)"],
  [18, "var(--perf-pos3)"],
]);
export const getDoomBotsWinrateColor = (percent) => doombotsRange[percent];
